var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#32CCCC",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 9.5C25.799 9.5 30.5 14.201 30.5 20C30.5 25.799 25.799 30.5 20 30.5C18.0057 30.5 16.0909 29.942 14.4357 28.9059C13.7616 28.4839 13.1372 27.9865 12.5749 27.4242C12.0118 26.861 11.5138 26.2355 11.0915 25.5602C10.0571 23.9059 9.5 21.9926 9.5 20C9.5 19.6803 9.51432 19.3622 9.5428 19.0463C9.60066 18.4046 10.1678 17.9313 10.8095 17.9891C11.4512 18.047 11.9246 18.6141 11.8667 19.2558C11.8445 19.5021 11.8333 19.7503 11.8333 20C11.8333 21.5519 12.2658 23.0371 13.0699 24.323C13.3986 24.8487 13.7863 25.3357 14.225 25.7744C14.6629 26.2124 15.1491 26.5997 15.6738 26.9281C16.9604 27.7335 18.4468 28.1667 20 28.1667C24.5103 28.1667 28.1667 24.5103 28.1667 20C28.1667 15.4897 24.5103 11.8333 20 11.8333C17.8168 11.8333 15.7816 12.696 14.2809 14.169L15.914 14.1707C16.5583 14.1707 17.0807 14.693 17.0807 15.3373C17.0807 15.9356 16.6303 16.4287 16.0501 16.4961L15.914 16.504H11.2457C10.6474 16.504 10.1543 16.0536 10.0869 15.4734L10.079 15.3373V10.6708C10.079 10.0264 10.6014 9.5041 11.2457 9.5041C11.844 9.5041 12.3371 9.95448 12.4045 10.5347L12.4124 10.6708L12.4119 12.7415C14.3604 10.7035 17.0782 9.5 20 9.5ZM19.125 14.1667C19.5677 14.1667 19.934 14.4961 19.992 14.923L20 15.0417V20H22.625C23.108 20 23.5 20.392 23.5 20.875C23.5 21.3177 23.1706 21.684 22.7437 21.742L22.625 21.75H19.125C18.6823 21.75 18.316 21.4206 18.258 20.9937L18.25 20.875V15.0417C18.25 14.5587 18.642 14.1667 19.125 14.1667Z",
    fill: "#32CCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon7);
export default __webpack_public_path__ + "static/media/icon7.1c6e9505b5b3502966ba6e71a338abee.svg";
export { ForwardRef as ReactComponent };